/**
* Overlapping Elements JS
* -----------------------------------------------------------------------------
*
* All the JS for the Overlapping Elements component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'overlapping-elements',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.overlapping-elements' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            scrub: 0.15,
            // markers: true,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-loaded' ),
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'overlapping-elements', COMPONENT );
} )( app );
